import { render, staticRenderFns } from "./rezervasyon.vue?vue&type=template&id=16679f72"
import script from "./rezervasyon.vue?vue&type=script&lang=js"
export * from "./rezervasyon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports